import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import FetchData, { GetOne } from "../../providers/dataProvider";

const ViewUser = () => {
  const location = useLocation();
  const [permission, setPermission] = useState([
    { value: "1", label: "View All User Data" },
    { value: "2", label: "Special Discount" },
  ]);

  const { data: Department } = FetchData("department");
  const { data: Designation } = FetchData("designation");
  const { data: userReport } = FetchData("userprofile");

  const [viewUser, setViewUser] = useState(null);

  useEffect(() => {
    if (viewUser?.userType === 2) {
      setPermission([{ value: "2", label: "Special Discount" }])
    }
  }, [viewUser?.userType])

  useEffect(() => {
    if (location?.state && Department && Designation && userReport) {
      const item = location.state;
      const itemCopy = { ...item };

      GetOne("userprofile", { id: itemCopy?.id }, (data) => {
        const mergedObject = {
          ...itemCopy,
          ...data.data,
        };

        const department = Department.find(
          ({ id }) => id === mergedObject?.departmentId
        );
        const designation = Designation.find(
          ({ id }) => id === mergedObject?.designationId
        );
        const reportingTo = userReport.find(
          ({ identityId }) => identityId === mergedObject?.reportingTo
        );

        const mergedObjectWithAddProperty = {
          ...mergedObject,
          departmentName: department?.departmentName ?? "",
          designationName: designation?.designationName ?? "",
          reportingTo: reportingTo
            ? `${reportingTo.firstName} ${reportingTo.lastName}`
            : "",
        };

        setViewUser(mergedObjectWithAddProperty);
      });
    }
  }, [location?.state, Department, Designation, userReport]);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: location.pathname,
        title: "View User",
        backTarget: { pathname: "/user-master" },
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          clear: true,
        },
      }));
    };
  }, [location.pathname]);

  return (
    <div className="container-fluid view-user-sec">
      <section className="user-view-sec mt-1">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-2">
            <div className="card mb-2">
              <div className="card-header pl-3">
                <h1>Personal Information</h1>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>User Type</h5>
                      <h6>{viewUser?.userTypeName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>User Name(Email Address)</h5>
                      <h6>{viewUser?.userName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>{viewUser?.userTypeName} First Name</h5>
                      <h6>{viewUser?.firstName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>{viewUser?.userTypeName} Last Name</h5>
                      <h6>{viewUser?.lastName}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Company Name</h5>
                      <h6>{viewUser?.companyName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Department</h5>
                      <h6>{viewUser?.departmentName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>User Role</h5>
                      <h6>{viewUser?.userRoleName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Phone Number</h5>
                      <h6>{viewUser?.phone}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Designation</h5>
                      <h6>{viewUser?.designationName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Reporting To</h5>
                      <h6>{viewUser?.reportingTo}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Block User</h5>
                      <h6>{viewUser?.isActive ? "No" : "Yes"}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Login Disabled</h5>
                      <h6>{viewUser?.loginDisabled ? "Yes" : "No"}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header pl-3">
                <h1>Special Permissions</h1>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                    <div className="row">
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
                        <div className="d-flex mb-2 flex-wrap">
                          {permission?.map((item) => (
                            <div className="form-group mb-0 mr-3">
                              <input
                                type="checkbox"
                                name="specialPermissions"
                                id={item?.value}
                                checked={viewUser?.specialPermissions?.includes(
                                  item?.value
                                )}
                                className="input-checkbox"
                                readOnly
                              />
                              <label
                                htmlFor={item?.value}
                                className="mr-2 mb-0 check-box-label"
                              >
                                {item?.label}
                              </label>
                            </div>
                          ))}
                          <div className="form-group mb-0 mr-3">
                            <input
                              type="checkbox"
                              name="canViewCostingOverride"
                              id="canViewCostingOverride"
                              checked={!!viewUser?.canViewCostingOverride}
                              className="input-checkbox"
                              readOnly
                            />
                            <label
                              htmlFor="canViewCostingOverride"
                              className="mr-2 mb-0 check-box-label"
                            >
                              View costing override
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  );
};

export default ViewUser;